export const RENDERING_ENVIRONMENTS_FOR_PAGE = 'page';
export const RENDERING_ENVIRONMENTS_FOR_COMPONENT = 'component';
export const RENDERING_ENVIRONMENTS_FOR_EDIT = 'edit';
export const SET_RENDERING_ENV = 'renderingEnv/set';

// category ids for homepage
export const CATEGORY_IDS = Object.freeze({
  HOMEPAGE: '2375500',
  PERSONALIZED_HOMEPAGE: '60198658'
});

// page templates
export const PAGE_TEMPLATES = Object.freeze({
  CAT_NAV: 'Category Nav',
  CAT_NAV_PRODUCT_RESULTS: 'Category Nav Product Results',
  DEFAULT: 'Default',
  FULL_WIDTH: 'Full Width',
  FULL_WIDTH_NO_GUTTERS: 'Full Width - No Gutters',
  PHP_TEMPLATE: 'Personalized Homepage Template',
  PDP: 'Product Page'
});

// page types
export const PAGE_TYPES = Object.freeze({
  APP: 'App',
  CONNECTED_DISPLAY: 'Connected Display',

  // NOTE this page type is only used by CAT_NAV_PRODUCT_RESULTS_ENV
  DEFAULT: 'Default',

  // TODO use this instead of DEFAULT
  CATEGORY_NAVIGATION_PRODUCT_RESULTS: 'Category Navigation Product Results',

  DYNAMIC: 'Dynamic',
  FLASH_EVENT: 'Flash Event Landing Page',
  HOMEPAGE: 'Homepage',
  PDP: 'Product Page',
  PERSONALIZED_HOMEPAGE: 'Personalized Homepage',
  RESPONSIVE_CONTENT: 'Responsive Content',
  SPACE: 'OliviaKim',
  STATIC_CONTENT: 'Static Content'
});

// rendering environment objects
export const APP_ENV = {
  name: 'App',
  supportedComponents: [
    'Accordion',
    'App Download Promos',
    'CardBannerPlacement - App',
    'Copy Only',
    'Dash Hudson Gallery - App',
    'Enticement Flag',
    'Checkout Error Banners',
    'Event Banner',
    'Experiment',
    'Explore More Tray',
    'Google Ad Manager Placement - App',
    'Greeting Random Tile - App',
    'HomePagePlacement - App',
    'Image Only - App',
    'Inspiration Hub Theme',
    'New Feature Banner - App',
    'NRHL Tile',
    'Outfit Recipe - App',
    'Recommendations - App',
    'Recommendations 3.0',
    'Responsive Carousel - App',
    'Responsive Staggered Group',
    'Style Swipes',
    'Stylist Media Galleries - App',
    'Tile - App',
    'Tile',
    'Video',
    'Whitespace'
  ],
  value: {
    pageTemplateName: PAGE_TEMPLATES.DEFAULT,
    pageType: PAGE_TYPES.APP
  }
};
export const CAT_NAV_PRODUCT_RESULTS_ENV = {
  name: 'Category Navigation Product Results',
  supportedComponents: [
    'Brand Banner',
    'Content Header',
    'Content Header Carousel',
    'Copy Only',
    'Dynamic Container',
    'Experiment',
    'GAM Displayed Ads',
    'Header Filter Below',
    'Header Filter Below Quiz',
    'Image Only',
    'Promo Tile',
    'Responsive Carousel',
    'SEO Content Block',
    'Tile',
    'Whitespace'
  ],
  value: {
    pageTemplateName: PAGE_TEMPLATES.CAT_NAV_PRODUCT_RESULTS,
    pageType: PAGE_TYPES.DEFAULT
  }
};
export const CONNECTED_DISPLAY_ENV = {
  name: 'Connected Display',
  supportedComponents: [
    'Connected Display Carousel',
    'IFrame',
    'Product Selection Image',
    'Video'
  ],
  value: {
    pageTemplateName: PAGE_TEMPLATES.DEFAULT,
    pageType: PAGE_TYPES.CONNECTED_DISPLAY
  }
};
export const FLASH_EVENT_LANDING_PAGE_ENV = {
  name: 'Flash Event Landing Page',
  supportedComponents: [
    'Brand Banner',
    'Content Header',
    'Content Header Carousel',
    'Copy Only',
    'Experiment',
    'Header Filter Below',
    'Header Filter Below Quiz',
    'Image Only',
    'Promo Tile',
    'Responsive Carousel',
    'SEO Content Block',
    'Tile',
    'Whitespace'
  ],
  value: {
    pageTemplateName: PAGE_TEMPLATES.CAT_NAV,
    pageType: PAGE_TYPES.FLASH_EVENT
  }
};
export const DYNAMIC_COMPONENT_ENV = {
  name: 'Dynamic Component',
  supportedComponents: [
    'About The Brand',
    'Active Viewer',
    'Container - App',
    'Dynamic Container',
    'Fashion Pillar',
    'Fashion Pillar Brand',
    'Fit Guide Container',
    'Fit Video Container',
    'Global Footer Banner Group',
    'Global Header Copy Group',
    'Global Messaging Banner Group',
    'PDP Copy Strings',
    'SEO Content Block',
    'Size Chart Container',
    'Size Fit Copy',
    'Size Fit Images',
    'Size Fit Table Group',
    'Size Fit Table',
    'Size Fit Video',
    'Store Amenities',
    'Story Responsive Staggered Group'
  ],
  value: {
    pageTemplateName: PAGE_TYPES.DYNAMIC,
    pageType: PAGE_TYPES.DYNAMIC
  }
};
export const HOMEPAGE_ENV = {
  name: PAGE_TYPES.HOMEPAGE,
  supportedComponents: [
    'Accordion',
    'Accordion Item Content',
    'Brands Recommendation Tray',
    'Copy Only',
    'Experiment',
    'Explore More Tile',
    'Explore More Tray',
    'GAM Displayed Ads',
    'HTML Block',
    'IFrame',
    'Image Only',
    'In Your Bag',
    'Jump Back In',
    'Looks Content Tray',
    'Looks Rec Tray',
    'MOW Category Tiles',
    'Personalized HP Tile',
    'Ranked Results',
    'Recommendations 3.0',
    'Responsive Carousel',
    'Responsive Staggered Group',
    'Revjet Content',
    'Tab',
    'Tab Item Content',
    'Tile',
    'Video',
    'Whitespace',
    'WishlistModule'
  ],
  value: {
    pageTemplateName: PAGE_TEMPLATES.FULL_WIDTH_NO_GUTTERS,
    pageType: PAGE_TYPES.HOMEPAGE
  }
};
export const PERSONALIZED_HOMEPAGE_ENV = {
  name: PAGE_TYPES.PERSONALIZED_HOMEPAGE,

  // same as HOMEPAGE_ENV
  supportedComponents: [
    'Accordion',
    'Accordion Item Content',
    'Copy Only',
    'Experiment',
    'Explore More Tile',
    'Explore More Tray',
    'HTML Block',
    'IFrame',
    'Image Only',
    'Looks Rec Tray',
    'Personalized HP Tile',
    'Ranked Results',
    'Recommendations 3.0',
    'Responsive Carousel',
    'Responsive Staggered Group',
    'Tab',
    'Tab Item Content',
    'Tile',
    'Video',
    'Whitespace'
  ],
  value: {
    pageTemplateName: PAGE_TEMPLATES.PHP_TEMPLATE,
    pageType: PAGE_TYPES.PERSONALIZED_HOMEPAGE
  }
};
export const PRODUCT_PAGE_ENV = {
  name: PAGE_TYPES.PDP,
  supportedComponents: [
    'ACTIVEVIEWER',
    'BANNERS',
    'BOFLEX',
    'Copy Only',
    'Enticement Flag',
    'Explore More Tile',
    'Experiment',
    'IFrame',
    'Image Only',
    'PDP Copy Strings',
    'PDP Container Module',
    'PDP Gift Options',
    'PDP Highlight',
    'PDP Module',
    'Product Highlight',
    'Product Highlight Category Container',
    'Product Highlights Container',
    'Product Page Price Lockup Shipping Text',
    'Product Page Shipping Details',
    'Selling Essentials Enticement Placements Container',
    'Tile'
  ],
  value: {
    pageTemplateName: PAGE_TEMPLATES.PDP,
    pageType: PAGE_TYPES.PDP
  }
};
export const RESPONSIVE_CONTENT_ENV = {
  name: PAGE_TYPES.RESPONSIVE_CONTENT,
  supportedComponents: [
    'Accordion',
    'Accordion Item Content',
    'Brands Recommendation Tray',
    'Copy Only',
    'Dynamic Container',
    'Email Signup Module',
    'Enticement Flag',
    'Experiment',
    'Explore More Tile',
    'Explore More Tray',
    'Fashion Pillar',
    'Fashion Pillar Brand',
    'Fashion Pillar Image',
    'Footer Links',
    'GAM Displayed Ads',
    'Global Header Copy',
    'Global Messaging',
    'HTML Block',
    'IFrame',
    'Image Only',
    'Looks Content Tray',
    'Looks Rec Tray',
    'MOW Category Tiles',
    'Personalized HP Tile',
    'Ranked Results',
    'Recommendations 3.0',
    'Responsive Carousel',
    'Responsive Staggered Group',
    'Revjet Content',
    'Single Look Card',
    'Single Look Rec Tray',
    'SEO Content Block',
    'Tab',
    'Tab Item Content',
    'Tile',
    'Video',
    'Whitespace',
    'WishlistModule'
  ],
  value: {
    pageTemplateName: PAGE_TEMPLATES.CAT_NAV,
    pageType: PAGE_TYPES.RESPONSIVE_CONTENT
  }
};
export const SPACE_ENV = {
  name: 'Space',

  // same as RESPONSIVE_CONTENT_ENV
  supportedComponents: [
    'Accordion',
    'Accordion Item Content',
    'Copy Only',
    'Experiment',
    'Explore More Tile',
    'Explore More Tray',
    'Global Header Copy',
    'Global Messaging',
    'IFrame',
    'Image Only',
    'Looks Rec Tray',
    'Personalized HP Tile',
    'Ranked Results',
    'Recommendations 3.0',
    'Responsive Carousel',
    'Responsive Staggered Group',
    'Tab',
    'Tab Item Content',
    'Tile',
    'Video',
    'Whitespace'
  ],
  value: {
    pageTemplateName: PAGE_TEMPLATES.CAT_NAV,
    pageType: PAGE_TYPES.SPACE
  }
};
export const STATIC_CONTENT_ENV = {
  name: PAGE_TYPES.STATIC_CONTENT,
  supportedComponents: ['Fit Guide Container', 'Size Chart Container', 'Static Container'],
  value: {
    pageTemplateName: PAGE_TEMPLATES.DEFAULT,
    pageType: PAGE_TYPES.STATIC_CONTENT
  }
};

// environment lists
export const renderingEnvironmentsForPage = [
  RESPONSIVE_CONTENT_ENV,
  HOMEPAGE_ENV,
  PERSONALIZED_HOMEPAGE_ENV,
  SPACE_ENV,
  CAT_NAV_PRODUCT_RESULTS_ENV,
  PRODUCT_PAGE_ENV,
  APP_ENV,
  CONNECTED_DISPLAY_ENV,
  FLASH_EVENT_LANDING_PAGE_ENV
];
export const renderingEnvironmentsForComponent = [
  RESPONSIVE_CONTENT_ENV,
  HOMEPAGE_ENV,
  SPACE_ENV,
  CAT_NAV_PRODUCT_RESULTS_ENV,
  DYNAMIC_COMPONENT_ENV,
  APP_ENV,
  CONNECTED_DISPLAY_ENV,
  STATIC_CONTENT_ENV
];
export const renderingEnvironmentsForEdit = [RESPONSIVE_CONTENT_ENV];

// additional options
export const responsiveContentOptions1 = [
  { name: 'Category Nav', value: 'Category Nav' },
  { name: 'Full-Width', value: 'Full Width' }
];
export const responsiveContentOptions2 = [
  { name: 'Gutters', value: '' },
  { name: 'No Gutters', value: 'No Gutters' }
];
export const responsiveContentOptions = {
  name: PAGE_TYPES.RESPONSIVE_CONTENT,
  pageType: PAGE_TYPES.RESPONSIVE_CONTENT,
  options: {
    responsiveContentOptions1,
    responsiveContentOptions2
  }
};
export const homepageContentOptions = {
  name: PAGE_TYPES.HOMEPAGE,
  pageType: PAGE_TYPES.HOMEPAGE,
  options: {
    responsiveContentOptions1,
    responsiveContentOptions2
  }
};
export const defaultOptions = {
  name: PAGE_TYPES.DEFAULT,
  pageType: PAGE_TYPES.DEFAULT,
  options: {
    responsiveContentOptions1,
    responsiveContentOptions2
  }
};
